import React from 'react';
import { Modal } from 'office-ui-fabric-react/lib/Modal';
import { DefaultButton } from 'office-ui-fabric-react/lib-commonjs/Button';
import { GLOBAL_PROJECT_TYPE_CHAMBER } from "../../lib/types";
import './modal-alert.css';

export default class ModalAlertComponent extends React.Component {
    render() {
        let {
            btnText,
            alertText,
            toggleAlert,
            productType,
            secondButton,
            switchProductType,
            toggleAlertAction,
            showAsHtml,
            addClassName,
            overrideTextAlign,
        } = this.props;

        productType = productType ? productType : GLOBAL_PROJECT_TYPE_CHAMBER;

        let resetParameters = {
            toggle: false,
            text: "",
            secondButton: {
                show: false,
                text: "",
            },
            showAsHtml: false,
            addClassName: null,
            overrideTextAlign: false,
        };

        return (
            <Modal
                isOpen={toggleAlert}
                isBlocking={false}
                onDismiss={
                    () => toggleAlertAction(resetParameters)
                }
                containerClassName={"modal-alert " + (addClassName ? addClassName : "")}
            >
                <div className="ms-fontColor-black" style={{ textAlign: "center" }}>
                    <div style={{ textAlign: (overrideTextAlign ? overrideTextAlign : "center"), margin: "0 20px 0 20px" }}>
                        <br />
                        {showAsHtml ? (<div dangerouslySetInnerHTML={{ __html: alertText }} />) : alertText}
                        <div style={{ height: "20px" }} />
                    </div>
                    <DefaultButton
                        primary
                        text={btnText !== undefined && btnText !== "" ? btnText : "Ok"}
                        onClick={() => {
                            toggleAlertAction(resetParameters);
                        }}
                    />
                    &nbsp; &nbsp;
                    {secondButton !== undefined && secondButton.show ?
                        <DefaultButton
                            primary
                            text={secondButton.text}
                            onClick={() => {
                                switchProductType(productType);
                                toggleAlertAction(resetParameters);
                            }}
                            style={{ border: "solid 1px white" }}
                        />
                        : null
                    }
                    <div style={{ height: "10px" }} />
                </div>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ModalAlert/modal-alert.component.js